module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IXYi2F/tc-custom/Cover.jpg?1650531188532?1684306039822",
      "alt": "This image is the cover for the book The Many Deaths of Laila Starr #1, The Many Deaths of Laila Starr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Many Deaths of Laila Starr #1, The Many Deaths of Laila Starr\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A powerful new series for fans of The Wicked + The Divine  and The Dreaming from Ram V (Justice League Dark) and Filipe Andrade (Captain Marvel) that explores the fine line between living and dying in Mumbai through the lens of magical realism. * With humanity on the verge of discovering immortality, the avatar of Death is fired and relegated to the world below to live out her now-finite days in the body of twenty-something Laila Starr in Mumbai. * Struggling with her new-found mortality, Laila has found a way to be placed in the time and place where the creator of immortality will be born... * But will Laila take her chance to permanently reverse the course of (future) history...or does a more shocking fate await her?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      V. Ram, Filipe Andrade\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0